import { Globe, Smartphone } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PcmpProjectVisibilityProps {
  isWebVisible: boolean;
  isMobileVisible: boolean;
}

const CHIP_CLASS = 'inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-xs font-medium';

export function PcmpProjectVisibility({
  isWebVisible,
  isMobileVisible,
}: PcmpProjectVisibilityProps) {
  return (
    <div className="flex items-center gap-1.5">
      <span
        className={cn(
          CHIP_CLASS,
          isWebVisible ? 'bg-muted text-foreground' : 'text-muted-foreground line-through',
        )}
        aria-label={isWebVisible ? 'Visible on web' : 'Hidden on web'}
      >
        <Globe className="size-3" />
        Web
      </span>
      <span
        className={cn(
          CHIP_CLASS,
          isMobileVisible ? 'bg-muted text-foreground' : 'text-muted-foreground line-through',
        )}
        aria-label={isMobileVisible ? 'Visible on mobile' : 'Hidden on mobile'}
      >
        <Smartphone className="size-3" />
        Mobile
      </span>
    </div>
  );
}
